import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";

export const useDeleteCourse = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: number) => adminApi.deleteCourse(id),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["courses"],
            });
        },
    });
};
